module.exports = __webpack_public_path__ + "img/O2O-ad-01.647ace38.png";